import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ITestCoupon } from 'src/app/_interfaces/coupons/i-test-coupon';
import { CouponsService } from 'src/app/_services/coupons.service';
import {
  CouponUsageTypes,
  TestVisitTypes,
  TestPercentageSections,
  TestTypes,
} from 'src/app/enums/test-coupon-enums';
import { showNotification } from 'src/app/helpers/show-toast';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { getActualDate } from 'src/app/helpers/get-actual-time';

@Component({
  selector: 'app-add-test-coupon',
  templateUrl: './add-test-coupon.component.html',
  styleUrls: ['./add-test-coupon.component.scss'],
})
export class AddTestCouponComponent implements OnInit {
  pageTitle: string = 'Coupons';
  couponDomain: number = 2;
  addCouponForm: FormGroup;
  isSubmited: boolean = false;
  tests = [];
  labs = [];
  cities = [];
  areas = [];
  branches = [];
  testsIds: string = '0';
  labsIds: string = '0';
  citiesIds: string = '0';
  areasIds: string = '0';
  branchesIds = null;
  isArea: boolean = false;
  isLab: boolean = false;
  isBranch: boolean = false;
  couponUsageTypes = CouponUsageTypes;
  testVisitTypes = TestVisitTypes;
  testPercentageSections = TestPercentageSections;
  testTypes = TestTypes;
  fromMinDate: Date;
  toMinDate: Date;
  coupon: ITestCoupon;
  isSelectedBranch: boolean = false;
  isDiscountPercentageEligibleTests: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private couponsService: CouponsService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.fromMinDate = new Date();
    this.toMinDate = new Date();
    this.fromMinDate.setDate(this.fromMinDate.getDate());
    this.toMinDate.setDate(this.toMinDate.getDate());
  }

  ngOnInit(): void {
    this.addCouponForm = this.formBuilder.group({
      enName: [
        null,
        [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)],
      ],
      arName: [
        null,
        [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)],
      ],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      discountPercentage: [
        null,
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ],
      ],
      ceiling: [null],
      usageType: [null, [Validators.required]],
      testType: [this.testTypes.All, [Validators.required]],
      tests: [null],
      discountPercentageDomain: [
        this.testPercentageSections.All,
        [Validators.required],
      ],
      visitType: [null],
      cities: [null],
      areas: [null],
      labs: [null],
      branches: [null],
    });

    this.getAllTests();
    this.getAllCities();
    this.getAllLabs();

    this.addCouponForm
      .get('cities')
      .valueChanges.subscribe((selectedCities) => {
        this.checkArea(selectedCities);
      });

    this.addCouponForm.get('areas').valueChanges.subscribe((selectedAreas) => {
      this.addCouponForm.patchValue({
        branches: null,
      });

      if (selectedAreas?.length) {
        this.checkBranch(selectedAreas, 'area');
      } else {
        if (this.addCouponForm.value.labs?.length) {
          this.areasIds = '0';
          this.checkBranch(this.addCouponForm.value.labs, 'lab');
        } else {
          this.isBranch = false;
        }
      }
    });

    this.addCouponForm.get('labs').valueChanges.subscribe((selectedLabs) => {
      this.addCouponForm.patchValue({
        branches: null,
      });

      if (selectedLabs?.length) {
        this.checkBranch(selectedLabs, 'lab');
      } else {
        if (this.addCouponForm.value.areas?.length) {
          this.labsIds = '0';
          this.checkBranch(this.addCouponForm.value.areas, 'area');
        } else {
          this.isBranch = false;
        }
      }
    });

    this.addCouponForm
      .get('branches')
      .valueChanges.subscribe((selectedBranches) => {
        if (selectedBranches?.length) {
          this.isSelectedBranch = true;
        } else {
          this.isSelectedBranch = false;
        }
      });
  }

  getAreasByCitiesIds(citiesIds) {
    this.couponsService.getAreasByCitiesIds(citiesIds).subscribe((res) => {
      this.areas = res?.data?.areas;
    });
  }

  checkArea(selectedCities) {
    this.isBranch = false;
    this.isArea = this.isLab = selectedCities?.length ? true : false;

    if (this.isArea) {
      this.citiesIds = this.generateItemsIds(
        this.cities,
        selectedCities,
        this.citiesIds,
        'id'
      );

      this.getAreasByCitiesIds(this.citiesIds);
    }

    this.addCouponForm.patchValue({
      areas: null,
      labs: null,
      branches: null,
    });
  }

  checkBranch(selectedData, changeSource) {
    this.isBranch = true;

    if (changeSource == 'area') {
      this.areasIds = this.generateItemsIds(
        this.areas,
        selectedData,
        this.areasIds,
        'id'
      );
    } else if (changeSource == 'lab') {
      this.labsIds = this.generateItemsIds(
        this.labs,
        selectedData,
        this.labsIds,
        'id'
      );
    }

    this.getCenterBranchesByCentersIdsAndAreasIds(this.labsIds, this.areasIds);
  }

  handleIsBranch() {
    if (
      this.addCouponForm.value.discountPercentageDomain !=
        this.testPercentageSections.HomeVisitFees &&
      this.addCouponForm.value.discountPercentageDomain !=
        this.testPercentageSections.All
    ) {
      this.isDiscountPercentageEligibleTests = true;
      return true;
    } else {
      this.isDiscountPercentageEligibleTests = false;
      return false;
    }
  }

  getAllTests() {
    this.couponsService.getAllTests().subscribe((res) => {
      this.tests = res?.data?.tests;
    });
  }

  getAllLabs() {
    this.couponsService.getAllLabs().subscribe((res) => {
      this.labs = res?.data?.centers;
    });
  }

  getAllCities() {
    this.couponsService.getAllCities().subscribe((res) => {
      this.cities = res?.data?.cities;
    });
  }

  getCenterBranchesByCentersIdsAndAreasIds(centersIds, areasIds) {
    this.couponsService
      .getCenterBranchesByCentersIdsAndAreasIds(centersIds, areasIds)
      .subscribe((res) => {
        this.branches = res?.data?.centerBranches;
      });
  }

  checkEndDate(startDate, endDate) {
    const couponStartDate = new Date(startDate);

    if (startDate > endDate) {
      endDate = new Date(couponStartDate.setDate(startDate.getDate()));
    }

    return endDate;
  }

  generateItemsIds(items, selectedItems, selectedItemsIds, idKey) {
    if (selectedItems?.length) {
      if (selectedItems.length == items.length) {
        selectedItemsIds = '0';
      } else {
        selectedItemsIds = selectedItems.map((item) => item[idKey]).join(',');
      }
    }

    return selectedItemsIds;
  }

  generateCopounObject(couponFormValue) {
    let startDate = getActualDate(couponFormValue.startDate, 2, true);

    let endDate = this.checkEndDate(
      couponFormValue.startDate,
      couponFormValue.endDate
    );

    endDate = getActualDate(endDate, 2, true);

    this.coupon = {
      domainId: this.couponDomain,
      couponName: couponFormValue.enName,
      arCouponName: couponFormValue.arName,
      startDate: startDate,
      endDate: endDate,
      discountPercentage: couponFormValue.discountPercentage,
      ceiling: couponFormValue.ceiling,
      usageTypeId: Number(couponFormValue.usageType),
      testTypeId: Number(couponFormValue.testType),
      testsIds: couponFormValue.tests?.length
        ? this.generateItemsIds(
            this.tests,
            couponFormValue.tests,
            this.testsIds,
            'id'
          )
        : '0',
      testPercentageSectionId: Number(couponFormValue.discountPercentageDomain),
      testVisitTypeId: Number(couponFormValue.visitType),
      citiesIds: this.citiesIds,
      areasIds: this.areasIds,
      centersIds: this.labsIds,
    };

    if (
      this.coupon.discountPercentage ==
      (this.testPercentageSections.All ||
        this.testPercentageSections.HomeVisitFees)
    ) {
      this.coupon['branchesIds'] = null;
    } else {
      this.coupon['branchesIds'] = couponFormValue.branches?.length
        ? this.generateItemsIds(
            this.branches,
            couponFormValue.branches,
            this.branchesIds,
            'id'
          )
        : null;
    }
  }

  onAddCouponSubmit() {
    this.isSubmited = true;

    this.generateCopounObject(this.addCouponForm.value);

    if (
      this.coupon.testPercentageSectionId ==
      this.testPercentageSections.HomeVisitFees
    ) {
      this.coupon.testVisitTypeId = 1;
      this.coupon.branchesIds = null;
    }

    if (this.coupon.branchesIds != null) {
      this.coupon.testVisitTypeId = 2;
    }

    if (this.addCouponForm.valid) {


      this.couponsService.addCoupon(this.coupon).subscribe((res) => {

        showNotification(
          'success',
          `The coupon with code '${res['data']['couponCode']}' has been added`,
          this.toastr
        );
        this.router.navigateByUrl('coupons');
      });
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
